module.exports = __webpack_public_path__ + "static/media/Southgrove Kitchen wall glazed.d25b81bb.JPG";